import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import React from 'react'
import GeneralStage from './GeneralStage'
import DestinationStage from './DestinationStage'
import SettleStage from './SettleStage'
import CurrenciesStage from './CurrenciesStage'

const EditBusinessTripSettingsForm = () => {
  return (
    <div className="tw-flex tw-min-h-[500px] tw-flex-col tw-gap-4 tw-p-4 tw-h-fit tw-overflow-y-auto">
      <GeneralStage />
      <DividerHorizontal />
      <DestinationStage />
      <DividerHorizontal />
      <SettleStage />
      <DividerHorizontal />
      <CurrenciesStage />
      
    </div>
  )
}

export default EditBusinessTripSettingsForm
